import cn from 'classnames';
import {useFormikContext} from 'formik';
import {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import AdvertismentMap from '../../../../../../components/advertisementMap';
import DotsLoading from '../../../../../../components/dotsLoading';
import FormikLikeInput from '../../../../../../components/formikFileds/likeInput';
import FormikTextArea from '../../../../../../components/formikFileds/textArea';
import CustomCheckbox from '../../../../../../components/mazraeKit/customCheckbox';
import ToggleSwitch from '../../../../../../components/mazraeKit/toggleSwitch';
import {useAuth} from '../../../../../../context/authContext';
import FloatingOnlySelectBottomSheet from '../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {RootState} from '../../../../../../store/redux';
import {
  addFormData,
  isSendingData,
} from '../../../../../../store/redux/advertisementRegisteration';
import Num2persian from '../../../../../../utilities/helper/convertNumToPersian';
import {ScrollSection} from '../../../../../../utilities/helper/scrollToError/errorScroll.constants';
import {getPriceUnits} from '../../../../../../utilities/helper/unitGenerator';
import {AdvertisementType} from '../../../../../../utilities/helper/unitGenerator/unit.types';
import {GroupNameToInputName} from '../../../../advertisementList/utils';
import {FromikType} from '../../../types';
import AdditionalInfo from '../../additionalInfo';
import AdvertisementUploadImage from '../../advertisementUploadImage';
import CommonField from '../../commonField';

const ProvidedServiceEmployeeForm = ({isLoading}: {isLoading?: boolean}) => {
  const {supplierProfile} = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myRef = useRef<HTMLDivElement | null>(null);

  const {setFieldValue, values, errors} = useFormikContext<FromikType>();

  const {input, sub_input, input_group, serviceBottomSheetData} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const [touched, setTouched] = useState<boolean>(false);
  const [location, setLocation] = useState<ILocation>({
    lat: Number(supplierProfile?.latlong?.[0]),
    lng: Number(supplierProfile?.latlong?.[1]),
  });

  useEffect(() => {
    setFieldValue('location', location);
  }, [location]);

  useEffect(() => {
    myRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [myRef.current]);

  useEffect(() => {
    let autoFillTitle = sub_input?.title;
    if (input?.title === 'کارشناس' && sub_input)
      autoFillTitle = `${input.title} ${sub_input?.title}`;
    setFieldValue('title', autoFillTitle);
  }, [sub_input]);

  return (
    <div className="flex flex-col gap-3">
      <section className="flex flex-col" id={ScrollSection.SUB_INPUT}>
        <div className="flex mb-2 text-gray-900 font-Medium" ref={myRef}>
          {input_group?.type === 'fertilizer' ||
          input_group?.type === 'pesticide' ? (
            <span className="text-md">
              نوع {input_group?.type && GroupNameToInputName[input_group?.type]}{' '}
              {input?.title} را وارد کنید.
            </span>
          ) : (
            <span className="text-md">
              {' '}
              نوع خدمت {input?.title} را وارد کنید.
            </span>
          )}
          <span className="color-red-3">*</span>
        </div>
        <div
          className={cn(
            'w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center',
            {
              '!border-red-550': touched && errors.sub_input?.title,
              '!border-farm-shop-500':
                values.sub_input?.title && !errors.sub_input?.title,
            },
          )}
        >
          {!sub_input?.title && (
            <i className="mx-1 text-xl text-gray-700 icon-nameSearch" />
          )}
          <input
            className="w-full bg-transparent text-md text-gray-950 placeholder:text-gray-700"
            name="sub_input"
            readOnly={true}
            value={sub_input?.title}
            placeholder="انتخاب نوع"
            onClick={() => {
              navigate('/advertisement-register-subInput-list', {
                state: {
                  input: input?.guid,
                  backRoute: '/advertisement-registeration',
                },
              });
            }}
          ></input>
        </div>
        <span className="pt-1 text-xs text-red-550">
          {touched && errors.sub_input?.title}
        </span>
      </section>
      <section id={ScrollSection.TITLE}>
        <p className="font-medium color-gray-1 text-md">
          عنوان آگهی <span className="color-red-3">*</span>
        </p>
        <FormikLikeInput
          name="title"
          label=""
          placeholder="عنوان آگهی"
          touched={sub_input?.title ? true : touched}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFieldValue('title', e.target.value);
          }}
        />
        <span className="text-xs text-gray-900">حداکثر 45 حرف</span>
      </section>
      <section id={ScrollSection.DESCRIPTION}>
        <FormikTextArea
          name="description"
          touched={values.description ? true : touched}
          placeholder=""
          description=""
          label="توضیحات"
          rows={5}
          labelClass="!text-md font-medium"
        />
        <span className="text-xs text-gray-900">
          درمورد مهارت ها و توانمندی های خود بنویسید.
        </span>
      </section>
      <AdvertisementUploadImage
        onClick={() => dispatch(addFormData(JSON.stringify(values)))}
      />

      <section id={ScrollSection.NAME}>
        <p className="mb-2 font-medium color-gray-1 text-md">
          نام و نام خانوادگی {input && input?.title} را وارد کنید
          <span className="color-red-3">*</span>
        </p>
        <FormikLikeInput
          name="name"
          touched={touched}
          label=""
          placeholder="مثلا: محمد احمدی"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFieldValue('name', e.target.value);
          }}
        />
      </section>
      <section id={ScrollSection.AD_PRICE}>
        <p className="mb-2 font-medium color-gray-1 text-md">
          دستمزد <span className="color-red-3">*</span>
        </p>
        <CommonField
          touched={touched}
          inputName="ad_price"
          bottomSheetName="price_unit"
          label=""
          firstInputPlaceHolder="قیمت به تومان"
          placeholder="واحد"
          secondaryTitle="تومان"
          commonBottomSheetData={getPriceUnits(
            serviceBottomSheetData as AdvertisementType,
            input_group?.code as number,
            input?.code,
          )}
          disabled={values?.negotiated_price}
          type="number"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.value.length < 12) {
              setFieldValue('ad_price', e.target.value);
            }
          }}
        />
        {values.ad_price && (
          <span className="text-xs text-farm-shop-500">
            {values?.employee_price_unit?.title}{' '}
            {Num2persian(values.ad_price?.toString())} تومان
          </span>
        )}
      </section>
      <section className="pr-1">
        <CustomCheckbox
          name="negotiated_price"
          title="تماس بگیرید"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            e.target.checked && setFieldValue('ad_price', '');
            setFieldValue('negotiated_price', e.target.checked);
            setFieldValue('discount_amount', '');
          }}
          checked={values?.negotiated_price}
        />
      </section>
      <section>
        <div className="flex justify-between items-center mt-8 mb-3">
          <span>تخفیف </span>
          <ToggleSwitch
            disabled={values?.negotiated_price}
            isToggled={values?.negotiated_price ? false : values?.has_discount}
            onToggle={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFieldValue('has_discount', e.target.checked);
              setFieldValue('discount_amount', '');
            }}
          />
        </div>
        <span className="text-gray-600 text-md">
          با اعمال تخفیف، آگهی در پیشنهادات شگفت انگیز نمایش داده می‌شود.
        </span>
      </section>
      <section id={ScrollSection.DISCOUNT}>
        <FormikLikeInput
          name="discount_amount"
          label=""
          placeholder="درصد تخفیف را وارد کنید"
          secondaryTitle="درصد"
          disabled={!values.has_discount || values?.negotiated_price}
          required={true}
          type="number"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (Number(e.target.value) <= 100) {
              setFieldValue('discount_amount', e.target.value);
            }
          }}
        />
        {values.discount_amount && (
          <span className="text-xs text-farm-shop-500">
            {Num2persian(values.discount_amount)} درصد تخفیف
          </span>
        )}
      </section>
      <section>
        <FloatingOnlySelectBottomSheet
          Placeholder="سایر مشخصات(اختیاری)"
          wrapperClass="border-gray-700"
          onClick={() => {
            navigate('/optional-registeration-info');
            dispatch(addFormData(JSON.stringify(values)));
          }}
        />
        <AdditionalInfo />
      </section>
      <section className="flex flex-col" id={ScrollSection.LOCATION}>
        <span className="mb-3 text-md">محدوده آگهی</span>
        <div className="z-0 edit-ads-map">
          <AdvertismentMap center={location} selectLocation={setLocation} />
        </div>
      </section>
      <section className="pr-1">
        <CustomCheckbox
          name="only_massage_buyer"
          title="فقط اجازه ارسال پیام به خریدار داده شود."
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setFieldValue('only_massage_buyer', e.target.checked)
          }
          checked={values?.only_massage_buyer}
        />
      </section>
      <button
        className={cn('mb-3 w-full h-12 text-white rounded', {
          'bg-farm-shop-200': isLoading,
          'bg-farm-shop-500': !isLoading,
        })}
        disabled={isLoading}
        type="submit"
        onClick={() => {
          dispatch(addFormData(JSON.stringify(values)));
          dispatch(isSendingData(true));
          setTouched(true);
        }}
      >
        {isLoading ? <DotsLoading /> : 'ثبت آگهی'}
      </button>
    </div>
  );
};

export default ProvidedServiceEmployeeForm;
